<div class="close-cross">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="participantModal">
  <mat-card>
    <h3>
      {{ "tpda.QRs" | translate }}
      <span *ngIf="data.QRs?.length">{{ ": " + data.QRs.length }}</span>
    </h3>
    <mat-card style="padding: 0px !important">
      <table mat-table matSort matSortDirection="desc" matSortActive="authored" [dataSource]="datasource">
        <ng-container matColumnDef="modified">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "model.patient.questionnaireDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.modified | date : "short" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="questionnaire">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matSortDirection="asc">
            {{ "model.patient.questionnaireName" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.questionnaire.display }}
          </td>
        </ng-container>

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "forms.internalId" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.subject.reference }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ "table.action" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              [disabled]="isDownloading"
              matTooltip="{{ 'tpda.downloadQRs' | translate }}"
              aria-label="icon button with an download icon"
              *ngIf="('dashboard/TPDA/QRsPDF' | isAuthorized | async) === true"
              (click)="downloadQRs(element)"
            >
              <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-file-archive"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator class="borderBox" #paginator [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" [hidePageSize]="false">
      </mat-paginator>
    </mat-card>
    <p class="text-center" *ngIf="!data.QRs || data?.QRs?.length === 0">
      {{ "widget.noData" | translate }}
    </p>
  </mat-card>
</div>
